function initializeProductGalleries(container = document) {
  container.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const mainImage = gallery.querySelector('[data-gallery-main]');
    const thumbnails = gallery.querySelectorAll('[data-gallery-thumbnail]');

    if (!mainImage || thumbnails.length === 0) {
      return;
    }

    thumbnails.forEach((thumbnail) => {
      if (thumbnail.dataset.galleryInitialized === 'true') {
        return;
      }

      thumbnail.dataset.galleryInitialized = 'true';

      thumbnail.addEventListener('click', () => {
        const newImage = thumbnail.dataset.fullImage;
        const newAlt = thumbnail.dataset.alt || '';

        if (!newImage) {
          return;
        }

        mainImage.classList.add('is-changing');

        const preloadImage = new Image();

        preloadImage.onload = () => {
          mainImage.removeAttribute('srcset');
          mainImage.src = newImage;
          mainImage.alt = newAlt;

          thumbnails.forEach((item) => {
            item.classList.remove('is-active');
          });

          thumbnail.classList.add('is-active');

          requestAnimationFrame(() => {
            mainImage.classList.remove('is-changing');
          });
        };

        preloadImage.src = newImage;
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initializeProductGalleries();

  document.querySelectorAll('[data-scroll-buy]').forEach((button) => {
    button.addEventListener('click', () => {
      document.querySelector('[data-product-form]')?.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    });
  });
});

/*
 * Ponowne uruchomienie galerii po przeładowaniu sekcji
 * w edytorze motywu Shopify.
 */
document.addEventListener('shopify:section:load', (event) => {
  initializeProductGalleries(event.target);
});